export default __webpack_public_path__ + "static/media/lala_d_secundaria.bf8558e5.png";